import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';
import { Button, Table } from 'antd';

import AllEdlApplicationsQuery from '../../graphql/queries/allEdlApplicationsQuery.graphql';
import Link from '../../components/general/Link';

const { Column } = Table;

const EdlAllApplications = ({ match }) => (
  <div className="contentBox">
    <h1>Applications</h1>
    <Query query={AllEdlApplicationsQuery} pollInterval={300000} fetchPolicy="network-only">
      {({ loading, error, data }) => {
        if (error) return `Error! ${error.message}`;

        const { loanApplications } = data;

        return (
          <Table loading={loading} dataSource={loanApplications} bordered rowKey="id">
            <Column title="Application Key" dataIndex="key" key="key" />
            <Column
              title="Applicant Name"
              key="name"
              render={(text, record) => `${record.firstName} ${record.lastName}`}
            />
            <Column title="Applicant Mobile" key="mobile" render={(text, record) => `+91 ${record.mobile}`} />
            <Column title="Applicant Email" dataIndex="email" key="email" />
            <Column
              title="Actions"
              key="actions"
              render={(text, record) => (
                <Fragment>
                  <Link to={`${match.url}/${record.id}`}>
                    <Button htmlType="button">View</Button>
                  </Link>
                </Fragment>
              )}
            />
          </Table>
        );
      }}
    </Query>
  </div>
);

EdlAllApplications.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
};

export default EdlAllApplications;



// WEBPACK FOOTER //
// ./src/pages/edl/EdlAllApplications.jsx